module.exports = __webpack_public_path__ + "img/fleet-plane.d4ce36e.png";